import React from 'react';
import styled from 'styled-components';
import { Notification, zIndex } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { token as previewToken } from '../../utils/preview';

// Waiting on final design. TODO: https://mixgenius.atlassian.net/browse/MG-36247
const PreviewNotificationWrapper = styled.div`
    position: fixed;
    top: 1rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: ${zIndex('subOverlay')};
    button {
        white-space: nowrap;
    }
    span {
        white-space: normal;
    }
    .notification {
        max-width: calc(100vw - 2rem);
        width: max-content;
        height: auto;
    }
`;

const exitPreview = () => {
    window.location.href = '/';
};

const PreviewNotification = () => {
    return previewToken ? (
        <PreviewNotificationWrapper>
            <Notification
                variant="danger"
                kind="temporary"
                onClose={exitPreview}
                className={'notification'}
            >
                <b>
                    <Trans>Preview Mode</Trans>
                </b>
                : <Trans>Close this dialog to exit preview mode.</Trans>
            </Notification>
        </PreviewNotificationWrapper>
    ) : null;
};

export default PreviewNotification;
